import { Edit } from 'react-admin';
import React from 'react';

import AreaInfoForm from './NearbyForm'

const MarketTitle = ({ record }) => {
    return <span>Area info {record ? `"${record.name}"` : ''}</span>;
};

export const NearbyEdit = (props) => (
    <Edit title={<MarketTitle />} {...props}>
        <AreaInfoForm />
    </Edit>
);




// WEBPACK FOOTER //
// ./src/components/nearby/NearbyEdit.js